"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Button = _interopRequireDefault(require("./Button"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _FabAdditional = _interopRequireDefault(require("./FabAdditional"));

require("./Button.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function FabButton(_ref) {
  var icon = _ref.icon,
      iconSize = _ref.iconSize,
      simple = _ref.simple,
      toolTipContent = _ref.toolTipContent,
      inverted = _ref.inverted,
      children = _ref.children,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["icon", "iconSize", "simple", "toolTipContent", "inverted", "children"]);

  var button;

  if (toolTipContent) {
    button = /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      key: "st_btn--fab-tooltip-" + (otherProps.key || 'default')
    }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"].Content, {
      position: "left"
    }, toolTipContent), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"].Trigger, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
      className: "st_btn--fab " + (inverted ? 'st_btn--fab-inverted' : '')
    }, otherProps), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      type: icon,
      size: "md"
    }))));
  } else {
    button = /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
      className: "st_btn--fab " + (inverted ? 'st_btn--fab-inverted' : '')
    }, otherProps), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      type: icon,
      size: "md"
    }));
  }

  if (simple) {
    return button;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_btn--fab-container"
  }, button, children);
}

FabButton.propTypes = {
  /**  name of icon */
  icon: _propTypes["default"].string.isRequired,

  /** icon size */
  iconSize: _propTypes["default"].oneOf(['sm', 'smd', 'md', 'mlg', 'lg']),

  /** boolen to specify if just the butotn in returned */
  simple: _propTypes["default"].bool,

  /** Changes inverts the style */
  inverted: _propTypes["default"].bool,

  /** Tooltip Content */
  toolTipContent: _propTypes["default"].string
};
FabButton.defaultProps = {
  iconSize: 'mlg',
  simple: false,
  inverted: false,
  toolTipContent: ''
};
FabButton.FabAdditional = _FabAdditional["default"];
FabButton.FabAdditional.displayName = 'FabButton.FabAdditional';
var _default = FabButton;
exports["default"] = _default;